import React from 'react';
import { ScrollButton } from './ui/ScrollButton';
export const StickyBar = () => {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-600 text-white shadow-md" data-id="element-376">
      <div className="container mx-auto flex min-h-[72px] items-center justify-center px-4 py-3 text-center text-base font-sans sm:text-lg" data-id="element-377">
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-5" data-id="element-378">
          <span className="flex items-center gap-2.5 font-sans tracking-wide" data-id="element-379">
            <span className="animate-pulse text-lg" data-id="element-380">⚠️</span>
            <span className="font-semibold uppercase text-sm sm:text-base tracking-widest" data-id="element-381">
              Precio de Lanzamiento
            </span>
            <span className="hidden opacity-80 sm:inline text-white/70" data-id="element-382">·</span>
            <span className="hidden opacity-80 sm:inline text-sm sm:text-base" data-id="element-383">
              Solo por tiempo limitado
            </span>
            <span className="hidden opacity-80 sm:inline text-white/70" data-id="element-384">·</span>
            <span className="font-bold text-brand-100 text-base sm:text-lg" data-id="element-385">
              $19.990 ARS
            </span>
          </span>
          <ScrollButton className="!bg-white !text-brand-700 hover:!bg-brand-50 !py-2.5 !px-6 !text-sm !font-semibold !shadow-sm !tracking-wide !uppercase" data-id="element-386">
            👇 Comprá Ahora
          </ScrollButton>
        </div>
      </div>
    </div>;
};